<template>
  <div class="shadow-wrapper user-order-count-card">
    <div class="img-wrapper">
      <img 
        :src="refs[type].icon" 
        alt="磐石保經"
      >
    </div>
    <div class="content">
      <span 
        class="count"
        :style="{color: [refs[type].color]}"
        v-text="count"
      />
      <h3 v-text="refs[type].title" />
    </div>    
  </div>
</template>

<script>
  export default {
    props: {
      count: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'car'
      }
    },
    data() {
      return {
        refs: {
          VCN: {
            color: '#ff6c36',
            title: '疫苗險防疫險',
            icon: require('@/assets/icon-vainnce.png')
          },  //20210530 Wen Add  modify SORT
          PET: {//20210530 Wen modify
            color: '#ff9900',
            title: '寵物險',
            icon: require('@/assets/icon-cat.png')
          },
          TRA: {
            color: '#ff6c36',
            title: '旅遊平安險',
            icon: require('@/assets/icon-travel.png')
          },
          AUT: {
            color: '#2d8cf0',
            title: '汽車險',
            icon: require('@/assets/icon-car.png')
          },
          MOT: {
            color: '#19be6b',
            title: '機車險',
            icon: require('@/assets/icon-bike.png')
          },  
          /*ANN: {
            color: '#ff9900',
            title: '年金險',
            icon: require('@/assets/icon-money.png')
          },
          ACD: { //20210830 Wen modify
            color: '#ff9900',
            title: '傷害險',
            icon: require('@/assets/icon-medical.png')
          }*/
        }
      };
    }
  };
</script>